var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 129,
    viewBox: "0 0 88 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 129,
    fill: "#122945"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 41,
    width: 26,
    height: 88,
    fill: "#122945"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 17,
    width: 27,
    height: 112,
    fill: "#122945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/Bar.00736fd2269a4df1a7e71221315a40f7.svg";
export { ForwardRef as ReactComponent };